module.exports = __webpack_public_path__ + "assets/img/title_2.a91679bd.png";